import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
} from "@mui/material";
import api from "api/axios";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [vendorFormData, setVendorFormData] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Address: "",
  });

  useEffect(() => {
    const fetchVendors = async () => {
      setLoading(true);
      try {
        const response = await api.get("/quickbooks/vendors/");
        const formattedVendors = (response.data.vendors || []).map((vendor) => ({
          vendor: vendor.DisplayName || "N/A",
          companyName: vendor.CompanyName || "N/A",
          phone: vendor.PrimaryPhone?.FreeFormNumber || "N/A",
          email: vendor.PrimaryEmailAddr?.Address || "N/A",
          tracking1099: vendor.Vendor1099 ? "Enabled" : "Disabled",
          balance: `$${Number(vendor.Balance || 0).toFixed(2)}`,
          actions: (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => console.log(`Editing vendor: ${vendor.Id}`)}
            >
              Edit
            </Button>
          ),
        }));

        setVendors(formattedVendors);
      } catch (err) {
        console.error("Failed to fetch vendors:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchVendors();
  }, []);

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => {
    setOpenDialog(false);
    setVendorFormData({ Name: "", Email: "", Phone: "", Address: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setVendorFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleVendorSubmit = async () => {
    try {
      await api.post("/quickbooks/vendors/", vendorFormData);
      setVendors((prev) => [...prev, vendorFormData]);
      handleDialogClose();
    } catch (err) {
      console.error("Failed to submit vendor:", err);
    }
  };

  const columns = [
    { Header: "Vendor", accessor: "vendor", align: "left" },
    { Header: "Company Name", accessor: "companyName", align: "left" },
    { Header: "Phone", accessor: "phone", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "1099 Tracking", accessor: "tracking1099", align: "center" },
    { Header: "Open Balance", accessor: "balance", align: "right" },
    { Header: "Action", accessor: "actions", align: "center" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="flex-end" mb={2}>
          <Button variant="contained" color="primary" onClick={handleDialogOpen}>
            Add Vendor
          </Button>
        </Grid>
        <MDBox pt={3}>
          <DataTable table={{ columns, rows: vendors }} isLoading={loading} noEndBorder />
        </MDBox>
      </MDBox>
      <Footer />

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Add Vendor</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            name="Name"
            value={vendorFormData.Name}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Email"
            name="Email"
            value={vendorFormData.Email}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Phone"
            name="Phone"
            value={vendorFormData.Phone}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Address"
            name="Address"
            value={vendorFormData.Address}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleVendorSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default Vendors;
